import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ItemsView from './view/ItemsView';
import ItemsDetails from './details/ItemsDetails';

import buttons from './ItemsButtons';
import events from './ItemsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('items'),
	routes: [
		{
			path: 'items/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'items'),
			element: (
				<DetailsPage
					key="items/add"
					module="items"
					tabs={ItemsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'items/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'items'),
			element: (
				<DetailsPage
					key="items/details"
					module="items"
					tabs={ItemsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'items/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'items'),
			element: (
				<ViewPage
					key="items/view"
					module="items"
					content={{ type: 'tabs', tabs: ItemsView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
